module.exports = __webpack_public_path__ + "img/img-01.11c0ff35.png";